import { PrivatePartyAPI } from 'client/data/api/api-client';
import { getAuthorizationToken } from 'client/site-modules/shared/utils/private-party/get-authorization-token';
import { logger } from 'client/utils/logger/logger';
import { buildFailedToFetchErrorValue } from 'client/site-modules/shared/utils/errors-handlers';

const DEFAULT_API_ERROR_MESSAGE = 'Something went wrong, please try again later.';
const AUTHORIZATION_API_ERROR_MESSAGE = 'Authorization failed!';

export const sendMessage = async ({ listingId, message, email, firstName, isAuthenticated, createOrUpdateIdmData }) => {
  let authorization = null;

  try {
    if (isAuthenticated) {
      authorization = await getAuthorizationToken();
    } else {
      await createOrUpdateIdmData({ idmDataToSave: {} });
      authorization = await getAuthorizationToken();
    }

    if (!authorization) {
      return { success: false, errorMessage: AUTHORIZATION_API_ERROR_MESSAGE };
    }
  } catch {
    return { success: false, errorMessage: AUTHORIZATION_API_ERROR_MESSAGE };
  }

  try {
    const { conversationId } = await PrivatePartyAPI.fetchJson(`/messaging/v1/conversations`, {
      method: 'POST',
      retries: 0,
      headers: { authorization, 'content-type': 'application/json' },
      body: JSON.stringify({ body: message, listingId, buyerEmail: email, buyerFirstName: firstName }),
      showAPIError: true,
    });

    return { conversationId };
  } catch (e) {
    if (e.status >= 500 || !e.status) {
      logger.error(e, `Failed to send message - ${e.message || e}`);
    } else {
      logger.warn(e, `Failed to send message - ${e.message || e}`);
    }

    return {
      errorMessage: !e.message || e.message?.includes('Failed to fetch') ? DEFAULT_API_ERROR_MESSAGE : e.message,
      errorStatus: e.status || '',
      errorMessageForTracking: buildFailedToFetchErrorValue(e),
    };
  }
};

export const blockSender = async ({ token, blockedReason }) => {
  return PrivatePartyAPI.fetchJson(`/messaging/v1/conversations/opt-out?t=${token}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ blockedReason }),
    showAPIError: true,
  });
};

export const reportSender = async ({ token, payload }) => {
  return PrivatePartyAPI.fetchJson(`/messaging/v1/conversations/reports?t=${token}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
    showAPIError: true,
  });
};
